import { Link } from "react-router-dom";
import '../styles/team.css';
import React, { useEffect, useState } from 'react';
import HeaderFFF from "../components/HeaderFFF";
import Header from '../components/Header'
import Footer from "../components/Footer";

export default function Team() {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 1000);
    
        useEffect(() => {
            const handleResize = () => {
                setIsMobile(window.innerWidth <= 991);
            };
    
            window.addEventListener('resize', handleResize);
            return () => window.removeEventListener('resize', handleResize);
        }, []);
    return(
        <>
        {isMobile ? <Header /> : <HeaderFFF />}
        <div id="team">
            <div id="team-header-container">
                <svg xmlns="http://www.w3.org/2000/svg" width="102" height="2" viewBox="0 0 102 2" fill="none">
                    <path d="M101 1H1" stroke="#BF9874" stroke-width="2" stroke-linecap="round"/>
                </svg>
                <h2>Our Team</h2>
                <svg xmlns="http://www.w3.org/2000/svg" width="102" height="2" viewBox="0 0 102 2" fill="none">
                    <path d="M101 1H1" stroke="#BF9874" stroke-width="2" stroke-linecap="round"/>
                </svg>
            </div>
            <div id="team-container">
                <div id="team-text">
                    <p>At the core of our firm are three dedicated partners and two associates, whose expertise, integrity and professionalism form the foundation of our trusted legal services.</p>
                </div>
                <div className="section">
                    <div className="member-title">
                    <h2>Partners</h2>
                    </div>
                    <div className="team-members">
                    {/* Lawyer list */}
                    <div className="member">
                        <Link to="george-corsianos">
                        <img src="https://t4.ftcdn.net/jpg/00/65/77/27/360_F_65772719_A1UV5kLi5nCEWI0BNLLiFaBPEkUbv5Fv.jpg" alt="/"></img>
                        <div className="member-name">
                            <h3>George<br/>Corsianos</h3>
                            <svg  xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none">
                                <path d="M11.4963 2.36291C11.5435 1.81265 11.1357 1.32834 10.5854 1.28118L1.61825 0.512704C1.06799 0.465546 0.583677 0.873397 0.53652 1.42367C0.489362 1.97393 0.897214 2.45824 1.44748 2.5054L9.41827 3.18849L8.73518 11.1593C8.68802 11.7095 9.09587 12.1938 9.64614 12.241C10.1964 12.2882 10.6807 11.8803 10.7279 11.33L11.4963 2.36291ZM1.64415 11.0427L11.1441 3.04243L9.85585 1.51263L0.355853 9.51287L1.64415 11.0427Z" fill="#222076"/>
                            </svg>
                        </div>
                        </Link>
                        {/*<p>Partner</p>*/}
                    </div>
                    <div className="member">
                        <Link to="jacob-lee">
                        <img src="https://t4.ftcdn.net/jpg/00/65/77/27/360_F_65772719_A1UV5kLi5nCEWI0BNLLiFaBPEkUbv5Fv.jpg" alt="/"></img>
                        <div className="member-name">
                            <h3>Jacob H. C.<br/> Lee</h3>
                            <svg  xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none">
                                <path d="M11.4963 2.36291C11.5435 1.81265 11.1357 1.32834 10.5854 1.28118L1.61825 0.512704C1.06799 0.465546 0.583677 0.873397 0.53652 1.42367C0.489362 1.97393 0.897214 2.45824 1.44748 2.5054L9.41827 3.18849L8.73518 11.1593C8.68802 11.7095 9.09587 12.1938 9.64614 12.241C10.1964 12.2882 10.6807 11.8803 10.7279 11.33L11.4963 2.36291ZM1.64415 11.0427L11.1441 3.04243L9.85585 1.51263L0.355853 9.51287L1.64415 11.0427Z" fill="#222076"/>
                            </svg>
                        </div>
                        </Link>
                        {/*<p>Partner</p>*/}
                    </div>
                    <div className="member">
                        <Link to="mick-vashishth">
                        <img src="https://t4.ftcdn.net/jpg/00/65/77/27/360_F_65772719_A1UV5kLi5nCEWI0BNLLiFaBPEkUbv5Fv.jpg" alt="/"></img>
                        <div className="member-name">
                            <h3>Mick<br/>Vashishth</h3>
                            <svg  xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none">
                                <path d="M11.4963 2.36291C11.5435 1.81265 11.1357 1.32834 10.5854 1.28118L1.61825 0.512704C1.06799 0.465546 0.583677 0.873397 0.53652 1.42367C0.489362 1.97393 0.897214 2.45824 1.44748 2.5054L9.41827 3.18849L8.73518 11.1593C8.68802 11.7095 9.09587 12.1938 9.64614 12.241C10.1964 12.2882 10.6807 11.8803 10.7279 11.33L11.4963 2.36291ZM1.64415 11.0427L11.1441 3.04243L9.85585 1.51263L0.355853 9.51287L1.64415 11.0427Z" fill="#222076"/>
                            </svg>
                        </div>
                        </Link>
                        {/*<p>Partner</p>*/}
                    </div>
                    </div>
                </div>
                <div className="section">
                    <div className="member-title">
                    <h2>Associates</h2>
                    </div>
                    <div className="team-members">
                        <div className="member">
                            <Link to="burke-heather">
                            <img src="https://t4.ftcdn.net/jpg/00/65/77/27/360_F_65772719_A1UV5kLi5nCEWI0BNLLiFaBPEkUbv5Fv.jpg" alt="/"></img>
                            <div className="member-name">
                                <h3>Burke<br/>Heather</h3>
                                <svg  xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none">
                                    <path d="M11.4963 2.36291C11.5435 1.81265 11.1357 1.32834 10.5854 1.28118L1.61825 0.512704C1.06799 0.465546 0.583677 0.873397 0.53652 1.42367C0.489362 1.97393 0.897214 2.45824 1.44748 2.5054L9.41827 3.18849L8.73518 11.1593C8.68802 11.7095 9.09587 12.1938 9.64614 12.241C10.1964 12.2882 10.6807 11.8803 10.7279 11.33L11.4963 2.36291ZM1.64415 11.0427L11.1441 3.04243L9.85585 1.51263L0.355853 9.51287L1.64415 11.0427Z" fill="#222076"/>
                                </svg>
                            </div>
                            </Link>
                            {/*<p>Associate</p>*/}
                        </div>
                    </div>  
                </div>
                <div className="section">
                    <div className="member-title">
                        <h2>Staff</h2>
                    </div>
                    <div className="team-members">
                        <div className="member">
                            <Link to="cathy-vashishth">
                            <img src="https://t4.ftcdn.net/jpg/00/65/77/27/360_F_65772719_A1UV5kLi5nCEWI0BNLLiFaBPEkUbv5Fv.jpg" alt="/"></img>
                            <div className="member-name">
                                <h3>Cathy<br/>Vashishth</h3>
                                <svg  xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none">
                                    <path d="M11.4963 2.36291C11.5435 1.81265 11.1357 1.32834 10.5854 1.28118L1.61825 0.512704C1.06799 0.465546 0.583677 0.873397 0.53652 1.42367C0.489362 1.97393 0.897214 2.45824 1.44748 2.5054L9.41827 3.18849L8.73518 11.1593C8.68802 11.7095 9.09587 12.1938 9.64614 12.241C10.1964 12.2882 10.6807 11.8803 10.7279 11.33L11.4963 2.36291ZM1.64415 11.0427L11.1441 3.04243L9.85585 1.51263L0.355853 9.51287L1.64415 11.0427Z" fill="#222076"/>
                                </svg>
                            </div>
                            </Link>
                            {/*}<p>Paralegal</p>*/}
                        </div>
                        <div className="member">
                            <Link to="phil-guarragi">
                            <img src="https://t4.ftcdn.net/jpg/00/65/77/27/360_F_65772719_A1UV5kLi5nCEWI0BNLLiFaBPEkUbv5Fv.jpg" alt="/"></img>
                            <div className="member-name">
                                <h3>Phil<br/>Guarragi</h3>
                                <svg  xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none">
                                    <path d="M11.4963 2.36291C11.5435 1.81265 11.1357 1.32834 10.5854 1.28118L1.61825 0.512704C1.06799 0.465546 0.583677 0.873397 0.53652 1.42367C0.489362 1.97393 0.897214 2.45824 1.44748 2.5054L9.41827 3.18849L8.73518 11.1593C8.68802 11.7095 9.09587 12.1938 9.64614 12.241C10.1964 12.2882 10.6807 11.8803 10.7279 11.33L11.4963 2.36291ZM1.64415 11.0427L11.1441 3.04243L9.85585 1.51263L0.355853 9.51287L1.64415 11.0427Z" fill="#222076"/>
                                </svg>
                            </div>
                            </Link>
                            {/*}<p>Paralegal</p>*/}
                        </div>
                        <div className="member">
                            <Link to="vara-leung">
                            <img src="https://t4.ftcdn.net/jpg/00/65/77/27/360_F_65772719_A1UV5kLi5nCEWI0BNLLiFaBPEkUbv5Fv.jpg" alt="/"></img>
                            <div className="member-name">
                                <h3>Vara<br/>Leung</h3>
                                <svg  xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none">
                                    <path d="M11.4963 2.36291C11.5435 1.81265 11.1357 1.32834 10.5854 1.28118L1.61825 0.512704C1.06799 0.465546 0.583677 0.873397 0.53652 1.42367C0.489362 1.97393 0.897214 2.45824 1.44748 2.5054L9.41827 3.18849L8.73518 11.1593C8.68802 11.7095 9.09587 12.1938 9.64614 12.241C10.1964 12.2882 10.6807 11.8803 10.7279 11.33L11.4963 2.36291ZM1.64415 11.0427L11.1441 3.04243L9.85585 1.51263L0.355853 9.51287L1.64415 11.0427Z" fill="#222076"/>
                                </svg>
                            </div>
                            </Link>
                            {/*}<p>Paralegal</p>*/}
                        </div>
                        <div className="member">
                            <Link to="sara-jane-carter">
                            <img src="https://t4.ftcdn.net/jpg/00/65/77/27/360_F_65772719_A1UV5kLi5nCEWI0BNLLiFaBPEkUbv5Fv.jpg" alt="/"></img>
                            <div className="member-name">
                                <h3>Sara-Jane<br/>Carter</h3>
                                <svg  xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none">
                                    <path d="M11.4963 2.36291C11.5435 1.81265 11.1357 1.32834 10.5854 1.28118L1.61825 0.512704C1.06799 0.465546 0.583677 0.873397 0.53652 1.42367C0.489362 1.97393 0.897214 2.45824 1.44748 2.5054L9.41827 3.18849L8.73518 11.1593C8.68802 11.7095 9.09587 12.1938 9.64614 12.241C10.1964 12.2882 10.6807 11.8803 10.7279 11.33L11.4963 2.36291ZM1.64415 11.0427L11.1441 3.04243L9.85585 1.51263L0.355853 9.51287L1.64415 11.0427Z" fill="#222076"/>
                                </svg>
                            </div>
                            </Link>
                            {/*}<p>Paralegal</p>*/}
                        </div>
                        
                    </div>  
                </div>
        </div>
    </div>
        <Footer />
        </>
    );
}